<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<!Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

    <div class="sdev-page-tabs">

        <div v-for="tab in tabs" :key="tab.key" class="sdev-page-tab " :class="{ 'is-active': activeTab === tab.key }"
            @click="selectTab(tab.key)">
            {{ tab.label }}
        </div>

    </div>

</template>

<script setup>

const props = defineProps({
    tabs: Array,
    activeTab: String
})

const emit = defineEmits(["update:activeTab"])

function selectTab(key) {
    emit("update:activeTab", key)
}

</script>